import DragAndDrop from '../../../../../../../UI/DragAndDrop';
import OInput from '../../../../../../../UI/FormControls/OInput';
import OAutocomplete from '../../../../../../../UI/MuiAutocomplete';
import { useTranslation } from 'react-i18next';

const NewDocumentForm = ({
  formData,
  setFormData,
  languageData,
  mainCategoryData,
  setFile,
  file,
}) => {
  const handleChange = (e) => {
    setFormData((curr) => {
      return { ...curr, [e.target.name]: e.target.value };
    });
  };

  const handleClickLanguage = (e) => {
    setFormData((curr) => {
      return { ...curr, nazivJezika: e.vrednost, idJezika: e.id };
    });
  };
  const handleClickMain = (e) => {
    setFormData((curr) => {
      return {
        ...curr,
        nazivGlavnaKategorija: e.vrednost,
        idGlavnaKategorija: e.id,
      };
    });
  };
  const handleFiles = (files) => {
    setFormData((curr) => {
      return { ...curr, nazivFajla: files[0].name };
    });
    setFile(files);
  };
  const handleUkloniFile = () => {
    setFile([]);
    setFormData((curr) => {
      return { ...curr, nazivFajla: '' };
    });
  };
  const { t, i18n } = useTranslation();
  return (
    <div>
      <DragAndDrop
        handleFiles={handleFiles}
        maxFiles={1}
        addedFiles={file}
        handleRemoveFile={handleUkloniFile}
      />
      <OInput
        label={`${t('fileName')} *`}
        name="nazivFajla"
        value={formData.nazivFajla}
        handleChange={handleChange}
        touched={formData.touchedNazivFajla}
        setTouched={() => {
          setFormData((curr) => {
            return { ...curr, touchedNazivFajla: true };
          });
        }}
        errorMessage={`${t('fileName')} ${t('isRequired')}`}
        style={{ width: '100%' }}
      />
      <OAutocomplete
        data={languageData}
        value={formData.nazivJezika}
        handleClick={handleClickLanguage}
        label={t('language')}
        style={{ width: '100%' }}
      />
      <OAutocomplete
        data={mainCategoryData}
        value={formData.nazivGlavnaKategorija}
        handleClick={handleClickMain}
        label={t('mainCategory')}
        style={{ width: '100%' }}
      />
      {/* <OInput
        label={`${t('category')}`}
        name="nazivKategorije"
        value={formData.nazivKategorije}
        handleChange={handleChange}
        touched={formData.touchedNazivKategorije}
        setTouched={() => {
          setFormData((curr) => {
            return { ...curr, touchedNazivKategorije: true };
          });
        }}
        errorMessage={`${t('category')} ${t('isRequired')}`}
        style={{ width: '100%' }}
      /> */}
      {/* <OAutocomplete
        data={categoryData}
        value={formData.nazivKategorije}
        handleClick={handleClickCategory}
        label={t('category')}
        style={{ width: '100%' }}
      /> */}
    </div>
  );
};

export default NewDocumentForm;
